<template>
  <div>
    <div>
      <aha-modal @hide="hide()" title="Leave presentation">
        <div v-if="leavePresentations.length === 1">
          <div>
            <p>
              You are leaving this shared presentation: <strong>
                {{ leavePresentations[0].name }} [{{ leavePresentations[0].accessCode }}]
              </strong>
            </p>
            <p>Once you leave, you can no longer edit it.</p>
          </div>
        </div>
        <div class="max-h-52" v-else>
          <span>Are you sure you want to leave these presentations:</span>
          <ul class="mt-2 ml-4 list-disc">
            <li
              class="mt-1"
              :key="presentation.id"
              v-for="presentation in leavePresentations"
            >
              {{ presentation.name }} [{{ presentation.accessCode }}]
            </li>
          </ul>
        </div>

        <template #action>
          <aha-button
            variant="danger"
            :disabled="leavingPresentations"
            @click="handleLeavePresentations()"
            icon-name="logout"
            :submitting="leavingPresentations"
            has-margin-right
          >
            <aha-spinner variant="white" class="mr-1" v-if="leavingPresentations" />
            Leave
          </aha-button>

          <aha-link @click="hide()">
            <span class="font-bold">Cancel</span>
          </aha-link>
        </template>
      </aha-modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

// api
import PresentationApi from '@/api/presentation'

// constants
import gaCategories from '@/constant/gaCategories'

// utils
import utils from '@/util'

export default {
  props: {
    leavePresentations: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leavingPresentations: false,
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setErrorOnInternalServerAction']),
    async handleLeavePresentations() {
      this.leavingPresentations = true

      try {
        await PresentationApi.removeCollaborators(this.leavePresentations[0].id, {
          collaborators: [this.currentUser.email],
        })
        this.$store.dispatch(
          'setPresentationsAction',
          this.$store.state.presentations.filter((p) => p.id !== this.leavePresentations[0].id),
        )

        if (this.leavePresentations.length === 1) {
          utils.showToastSuccess('Left this presentation successfully.')
        } else {
          utils.showToastSuccess(`Leave ${this.leavePresentations.length} presentations`)
        }

        utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Presentation > Leave collaboration > Succeeded')
      } catch (error) {
        if (this.leavePresentations.length === 1 && this.leavePresentations[0]) {
          this.setErrorOnInternalServerAction(`Cannot leave presentation ${this.leavePresentations[0].name}`)
        } else {
          this.setErrorOnInternalServerAction(`Cannot leave ${this.leavePresentations.length} presentations`)
        }

        utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Presentation > Leave collaboration > Failed')
        throw error
      } finally {
        this.leavingPresentations = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
